import { DatumValue } from "@nivo/line";

type ChartTooltip = {
  externalLink?: { path: string };
  internalLink?: { to: string | object; text: string };
  text: React.ReactNode;
};

export type ChartTab = {
  name: string;
  query?: string;
  tooltip: ChartTooltip;
  value: number;
  formatCurrency?: boolean;
  formatNumber?: boolean;
  formatToPercentage?: boolean;
};

export enum AggregationType {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year",
}

export type AggregationTypeUnion = `${AggregationType}`;

export type ChartInterval = {
  intervalLabel: string;
  aggregationType?: AggregationTypeUnion;
  intervalStartDate?: string;
  intervalEndDate?: string;
};

export enum ChartId {
  MAIN = "main",
  COMPARATIVE = "comparative",
}

export type LineChartId = `${ChartId}`;

export interface LineChartData {
  id: LineChartId | string;
  color: string;
  data: { x: DatumValue; y: DatumValue }[];
  legendIcon?: React.ReactNode;
  legendLabel?: string;
  multiline?: boolean;
}

export type TooltipData = {
  y: DatumValue;
  x: DatumValue;
  yFormatted: string | number;
  xFormatted: string | number;
  comparativeDate?: string | number;
  isPercentageValue?: boolean;
};
